import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { useSelector } from "react-redux";
import { getPrepledgeLoanDues } from "../Ornamentv2/OrnamentV2Api";
import { parseAndSetFlag } from "utils/Utils";
const ShowDisbursalLoanData = ({
  editable,
  classes,
  prePledgeLoan,
  repledgeCase,
  notEligibleTopUpAccountType,
  setMainActualLoanAmount,
  prepledgeLoanAmount,
  featureFlag,
}) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [actualLoanAmount, setActualLoanAmount] = useState(prepledgeLoanAmount);
  const { authToken } = useSelector((state) => state.login.authData);
  const closureTimePayableAdjust = parseAndSetFlag(featureFlag?.closureTimePayableAdjust)
  const closureTimeExceedAmount = parseAndSetFlag(featureFlag?.closureTimeExceedAmount)
  const [callInProgress, setCallInProgress] = useState(false);
  const [adjustedAccountNumber, setAdjustedAccountNumber] = useState(
    repledgeCase ? prePledgeLoan : ""
  );
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    if (notEligibleTopUpAccountType) {
      setActualLoanAmount(prepledgeLoanAmount);
    }
  }, [prepledgeLoanAmount]);
  useEffect(() => {
    if (repledgeCase && !notEligibleTopUpAccountType) {
      GetLoanClosureDuesDetails(prePledgeLoan);
    }
  }, []);
  const GetLoanClosureDuesDetails = async () => {
    const prePledgeLoanData = await getPrepledgeLoanDues(
      authToken,
      setCallInProgress,
      prePledgeLoan || adjustedAccountNumber,
      toastUpdate,
      featureFlag
    );
    const value = Number(prePledgeLoanData?.totalDues) - Number(prePledgeLoanData?.interestWaiveOffAmt) - (closureTimePayableAdjust ? Number(prePledgeLoanData?.payableAmount) : 0) + (closureTimeExceedAmount ? Number(prePledgeLoanData?.excessInterestAmount) : 0);
    setActualLoanAmount(value);
    if (notEligibleTopUpAccountType) {
      setMainActualLoanAmount(value);
    }
  };
  return (
    <div>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField
              label="Adjusted Loan Account Number"
              required
              id="adjusted_loan_acc_number"
              value={adjustedAccountNumber?.toUpperCase()}
              setState={setAdjustedAccountNumber}
              disabled={!editable}
              setBlur={GetLoanClosureDuesDetails}
              type="notCapital"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            className={`${classes.fieldContaienr} ${classes.removeMarginInput}`}
          >
            <CustomTextField
              label="Adjusted Loan Amount"
              id="loan_amount"
              value={actualLoanAmount || "0"}
              disabled
              setError={setActualLoanAmount}
            />
          </Grid>

          {toast && (
            <ToastModal
              toastMessage={toastMessage}
              toastMessageType={toastMessageType}
              toastUpdate={toastUpdate}
            />
          )}
          {callInProgress && (
            <CircularProgress callInProgress={callInProgress} />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

ShowDisbursalLoanData.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default ShowDisbursalLoanData;
